import { Line, Sparkles, Text } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import { RigidBody, CuboidCollider } from "@react-three/rapier";
import { COLORS } from "../../constants/colors";
import { useGame } from "../../stores/useGame";
import useDeviceType from "../hooks/useDeviceType";

const BORDER_COLOR = COLORS.surfaceElements;
const SIZE = 2.8;

const points = [
  [-SIZE, 0, -SIZE],
  [SIZE, 0, -SIZE],
  [SIZE, 0, SIZE / 4],
  [-SIZE, 0, SIZE / 4],
  [-SIZE, 0, -SIZE], // замыкаем контур
];

const SurfaceButtonStart = ({ position }) => {
  const lineRef = useRef();
  const { isStartButtonActive, setStartButtonActive } = useGame();
  const deviceType = useDeviceType();

  useFrame(({ clock }) => {
    if (lineRef.current) {
      const time = clock.getElapsedTime();

      if (isStartButtonActive) {
        // Пульсирующая толщина линии
        const pulseWidth = 8 + Math.sin(time * 3) * 4;
        lineRef.current.material.linewidth = pulseWidth;

        // Пульсирующий цвет от #cbb9af к более яркому оттенку
        const colorIntensity = 0.5 + Math.sin(time * 2) * 0.3;
        lineRef.current.material.color.setRGB(
          0.8 + colorIntensity * 0.2, // R (из #cbb9af = 203/255 ≈ 0.8)
          0.73 + colorIntensity * 0.27, // G (из #cbb9af = 185/255 ≈ 0.73)
          0.69 + colorIntensity * 0.31 // B (из #cbb9af = 175/255 ≈ 0.69)
        );
      } else {
        // Возвращаем к исходному цвету #cbb9af
        lineRef.current.material.linewidth = 10;
        lineRef.current.material.color.setRGB(0.8, 0.73, 0.69); // #cbb9af
      }
    }
  });

  return (
    <group position={position}>
      <RigidBody
        type="fixed"
        sensor={true}
        ccd={false}
        userData={{ isButtonStart: true }}
        position-z={-1}
        position-y={1}
        onIntersectionEnter={(other) => {
          if (other.rigidBodyObject?.userData?.isCar) {
            setStartButtonActive(true);
          }
        }}
        onIntersectionExit={(other) => {
          if (other.rigidBodyObject?.userData?.isCar) {
            setStartButtonActive(false);
          }
        }}
      >
        <CuboidCollider args={[SIZE, 0.01, SIZE / 1.5]} />
      </RigidBody>

      <Line
        ref={lineRef}
        points={points}
        color={BORDER_COLOR}
        lineWidth={isStartButtonActive ? 8 : 10}
        dashed={false}
      />
      <Text
        fontSize={0.9}
        color={"white"}
        rotation-x={-Math.PI / 2}
        position={[0, 0, -1]}
      >
        {isStartButtonActive
          ? deviceType === "mobile" || deviceType === "tablet"
            ? "GO"
            : "ENTER"
          : "START"}
      </Text>
      {isStartButtonActive && (
        <Sparkles
          position={[0, 0.5, -2]} // чуть выше поверхности
          count={40}
          scale={[SIZE * 2, SIZE, SIZE * 2]} // область чуть меньше квадрата
          size={10}
          speed={1}
          color={"white"}
          opacity={1}
        />
      )}

      {/* Линия слева от кнопки (перпендикулярно) */}
      <mesh position={[-3.6, 0, 0]} rotation={[0, 0, Math.PI / 2]}>
        <cylinderGeometry args={[0.05, 0.05, 1, 8]} />
        <meshBasicMaterial color="white" />
      </mesh>

      {/* Надпись "stay here" слева */}
      <Text
        fontSize={0.4}
        color={"white"}
        rotation-x={-Math.PI / 2}
        position={[-5.3, 0, 0]}
      >
        STAY HERE
      </Text>
    </group>
  );
};

export default SurfaceButtonStart;
